import { Controller } from '@hotwired/stimulus';
import CodeMirror, { EditorFromTextArea } from 'codemirror';

export default class CustomActionsFormController extends Controller {
  static targets = [
    'codeBlock',
  ]

  declare readonly codeBlockTargets:HTMLElement[];

  editorTextAreas:{ [index:string]:EditorFromTextArea } = {};

  codeBlockTargetConnected(element:HTMLElement) {
    let textArea:HTMLTextAreaElement;
    if (element instanceof HTMLInputElement) {
      let input = element as HTMLInputElement
      textArea = document.createElement("TEXTAREA") as HTMLTextAreaElement
      textArea.name = input.name
      textArea.defaultValue = input.getAttribute("value") as string
      element.replaceWith(textArea)
    } else if (element instanceof HTMLTextAreaElement) {
      textArea = element
    } else {
      return
    }
    let cm = this.editorTextAreas[textArea.name] = CodeMirror.fromTextArea(textArea, {
      mode: 'ruby',
      tabSize: 2,
      lineNumbers: true,
      lineWrapping: true,
      autoRefresh: true,
      styleActiveLine: true,
      viewportMargin: Infinity,
      indentWithTabs: true,
    });
    if (cm.getValue().length > 0) {
      let collapsible = cm.getWrapperElement().closest('.-collapsible')
      if (collapsible) {
        collapsible.classList.remove('collapsed');
        collapsible.getElementsByTagName('div')[0].style.display = 'block';
      }
    }
  }
}
